// extracted by mini-css-extract-plugin
export default {"inlineAlert":"InlineAlert_inlineAlert__oXkgd","text":"InlineAlert_text__K3Y-H","error":"InlineAlert_error__gdJaw","success":"InlineAlert_success__8RHXC"};